import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';

interface ViewChatBotLogProps extends RouteComponentProps<{ contract_id: string }> {
    changeToggle(action?: boolean): void
}

@observer export default class ViewChatBotLog extends React.Component<ViewChatBotLogProps> {

    @observable private logs: any[] = [];
    @observable private contractId = '';
    @observable private clientName = '';
    @observable private redirect = false;
    @observable private isLoaded = false;
    @observable private sortNewestFirst = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const contractId = this.props.match.params.contract_id;
        if (!contractId || contractId === "undefined") {
            toast.error("Error cargando el historial del chatbot");
            this.redirect = true;
            return;
        }

        this.contractId = contractId;
        http.get(`/api/chatbot_log/contract/${contractId}`).then((response) => {
            this.logs = this.extractLogs(response.data);
            const logWithName = this.logs.find((log) => log.client_name);
            this.clientName = logWithName ? logWithName.client_name : '';
            this.isLoaded = true;
        }).catch(() => {
            toast.error("Error cargando el historial del chatbot");
            this.redirect = true;
        });
    }

    private extractLogs = (data: any): any[] => {
        const logs = Array.isArray(data)
            ? data
            : Array.isArray(data?.response)
                ? data.response
                : Array.isArray(data?.response?.data)
                    ? data.response.data
                    : [];

        return [...logs];
    }

    private getSortedLogs = (): any[] => {
        return [...this.logs].sort((a, b) => {
            const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
            const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
            return this.sortNewestFirst ? dateB - dateA : dateA - dateB;
        });
    }

    private toggleSortOrder = (): void => {
        this.sortNewestFirst = !this.sortNewestFirst;
    }

    private getMessage = (log: any): string => {
        const message = log.user_message || log.message || '';
        return message.trim() || '-';
    }

    private getResponse = (log: any): string => {
        const response = log.ai_response || log.response || log.bot_response || '';
        return response.trim() || '-';
    }

    private formatDate = (date: string): string => {
        if (!date) {
            return '-';
        }
        return new Date(date).toLocaleString('es-MX', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    }

    private renderChatMessages = () => {
        const sortedLogs = this.getSortedLogs();

        if (sortedLogs.length === 0) {
            return (
                <div className="chat-log-empty">
                    No hay mensajes para este contrato
                </div>
            );
        }

        return (
            <div className="chat-log-container">
                {sortedLogs.map((log, index) => {
                    const userMessage = this.getMessage(log);
                    const botResponse = this.getResponse(log);
                    const time = this.formatDate(log.created_at);

                    return (
                        <div className="chat-exchange" key={index}>
                            {userMessage !== '-' &&
                                <div className="chat-message chat-message--user">
                                    <div className="chat-bubble chat-bubble--user">
                                        <span className="chat-bubble-label">
                                            {this.clientName || 'Cliente'}
                                        </span>
                                        <p>{userMessage}</p>
                                        <span className="chat-time">{time}</span>
                                    </div>
                                </div>
                            }
                            {botResponse !== '-' &&
                                <div className="chat-message chat-message--bot">
                                    <div className="chat-bubble chat-bubble--bot">
                                        <span className="chat-bubble-label">Asistente Virtual</span>
                                        <p>{botResponse}</p>
                                        <span className="chat-time">{time}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    );
                })}
            </div>
        );
    }

    render() {
        if (this.redirect) {
            return <Redirect to="/chatbot-logs" />;
        }
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row chat-log-view">
                    <div className="col-md-12">
                        <div className="card chat-log-card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">
                                        Historial del chat - Contrato #{this.contractId}
                                        {this.clientName ? ` - ${this.clientName}` : ''}
                                    </h4>
                                </div>
                            </div>
                            <div className="card-body chat-log-card-body">
                                <div className="chat-log-toolbar">
                                    <button
                                        onClick={this.toggleSortOrder}
                                        className="btn btn-info btn-sm"
                                    >
                                        <i className="material-icons">{this.sortNewestFirst ? 'arrow_downward' : 'arrow_upward'}</i>
                                        {this.sortNewestFirst ? ' Más recientes' : ' Más antiguos'}
                                    </button>
                                    <Link to={`/chatbot-logs`}>
                                        <button className="btn btn-danger btn-sm">
                                            <i className="material-icons">highlight_off</i>
                                            <div className="ripple-container"></div>
                                        </button>
                                    </Link>
                                </div>
                                <div className="chat-log-wrapper">
                                    {this.renderChatMessages()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
